module.exports = __webpack_public_path__ + "img/1.349b2af9.jpg";